import { AxiosInstance } from "axios"
import {
    MeetingServiceOrder,
    ReportDetails,
} from "../../../../company/reports/accounting/meetingService/meetingServiceTypes"

export enum SupplierMeetingServiceQuery {
    MEETING_SERVICE_ORDERS_FOR_SUPPLIER = "meeting-service-orders-for-supplier-reports",
}

type MeetingServiceOrdersForSupplierParams = Readonly<{
    supplierId: number
    orderId?: string
    pendingApproval?: boolean
    invoiceStatus?: string
    isBooked?: string
    startBookedDate?: string
    endBookedDate?: string
    startDeliveryDate?: string
    endDeliveryDate?: string
    merchantId?: string
    merchantIds?: string
    customerId?: string
    userGroupId?: string
    email?: string
    paymentMethod?: string
    creditCardLast4?: string
    shopIds?: string
    satelliteIds?: string
    buyerPartyIds?: string
}>

export type MeetingServiceOrdersForSupplierResponse = Readonly<{
    reportDetails: ReportDetails
    orders: MeetingServiceOrder[]
}>

export async function fetchMeetingServiceOrdersForSupplier(
    params: MeetingServiceOrdersForSupplierParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<MeetingServiceOrdersForSupplierResponse> {
    const { supplierId, startBookedDate, endBookedDate, ...rest } = params
    const url = `/suppliers/${params.supplierId}/accounting/meetingService/orders`

    const { data } = await axios.get(url, {
        // the endpoint scopes by booked date via startDate/endDate
        params: { ...rest, startDate: startBookedDate, endDate: endBookedDate },
        signal,
    })

    return data
}
